import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useCustomerTicketsPage } from "modules/customerTickets/pages/CustomerTickets/context";
import React from "react";
import { COLOR_GREY_12 } from "shared/theme/colors";

const TopContent = () => {
  const { selectedTicket, selectedUserId } = useCustomerTicketsPage();

  return (
    <Box display="flex" flexDirection="column" rowGap="0.5rem">
      <Box display="flex" justifyContent="space-between">
        <Typography variant="bodySSemiBold" color={COLOR_GREY_12}>
          Preferred name:
        </Typography>
        <Typography variant="bodySSemiBold" color={COLOR_GREY_12}>
          {selectedTicket?.userName}
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="bodySSemiBold" color={COLOR_GREY_12}>
          User ID:
        </Typography>
        <Typography variant="bodySSemiBold" color={COLOR_GREY_12}>
          {selectedUserId}
        </Typography>
      </Box>
    </Box>
  );
};

export default TopContent;
